import React, { useEffect } from 'react'; //
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { HistoryRouter as Router } from 'redux-first-history/rr6';
import { LazyMotion, domMax } from 'framer-motion';
import Platform from './Platform.jsx';
import { history, persistor, store } from './redux/lib/configureStore.js';
import { ClerkProvider } from '@clerk/clerk-react';
import AuthProvider from './lib/contexts/auth.jsx';
import setEnvironmentFavicon from './lib/setEnvironmentFavicon.js';
import PostHogWrapper from '@/components/PostHogWrapper.jsx';

import './styles/main.scss';

const prodKey = 'pk_live_Y2xlcmsubWluZGNsb3VkLmNvJA';
const devKey = 'pk_test_cmVuZXdpbmctcmFtLTU0LmNsZXJrLmFjY291bnRzLmRldiQ';
const finalKey = import.meta.env.DEV ? devKey : prodKey;

function App() {
  useEffect(() => {
    setEnvironmentFavicon(); //
  }, []);

  return (
    <Provider store={store}>
      <Router history={history}>
        <PersistGate loading={null} persistor={persistor}>
          <ClerkProvider publishableKey={finalKey}>
            <AuthProvider>
              <PostHogWrapper>
                <LazyMotion features={domMax}>
                  <Platform />
                </LazyMotion>
              </PostHogWrapper>
            </AuthProvider>
          </ClerkProvider>
        </PersistGate>
      </Router>
    </Provider>
  );
}

export default App;
